<ng-container *transloco="let t">
    <div class="container top-nav-bar" fxLayout="row" fxLayout.lt-md="column">
        <div
            fxFlex="20"
            fxFlex.lt-md="100"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="center center"
            class="left"
        >
            <a
                href="javascript:void(0)"
                fxLayout="row"
                fxLayoutAlign="center center"
                (click)="navigation('provider')"
            >
                <mat-icon>arrow_back</mat-icon>
                {{ t("application.back-to-programs") }}
            </a>
        </div>
        <div
            fxFlex="80"
            fxFlex.lt-md="100"
            fxLayoutAlign="center center"
            fxLayoutAlign.sm="center center"
            class="center"
            fxLayout="row"
            fxLayout.lt-md="column"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutAlign.lt-md="space-between center"
                class="top-nav-menu"
                fxFlexFill
            >
                <a
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    (click)="navigation('application/personal-information')"
                    [class.active]="
                        isStepActive('application/personal-information')
                    "
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/personal-info-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{
                        t("application.tab.personal-info")
                    }}</span>
                </a>
                <div class="separator" fxHide.xs></div>
                <a
                    *ngIf="application?.isPersonalInfoComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    (click)="navigation('application/background')"
                    [class.active]="isStepActive('application/background')"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/demographics-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{ t("application.tab.background") }}</span>
                </a>
                <a
                    *ngIf="!application?.isPersonalInfoComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    class="page-disabled"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/demographics-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{ t("application.tab.background") }}</span>
                </a>
                <div class="separator" fxHide.xs></div>
                <a
                    *ngIf="application?.isBackgroundComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    (click)="navigation('application/your-education')"
                    [class.active]="isStepActive('application/your-education')"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/your-education-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{
                        t("application.tab.your-education")
                    }}</span>
                </a>
                <a
                    *ngIf="!application?.isBackgroundComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    class="page-disabled"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/your-education-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{
                        t("application.tab.your-education")
                    }}</span>
                </a>
                <div class="separator" fxHide.xs></div>
                <a
                    *ngIf="application?.isEducationComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    (click)="navigation('application/disclosure')"
                    [class.active]="isStepActive('application/disclosure')"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/disclosure-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{ t("application.tab.disclosure") }}</span>
                </a>
                <a
                    *ngIf="!application?.isEducationComplete"
                    href="javascript:void(0)"
                    fxLayout="row"
                    fxLayout.lt-md="column"
                    fxLayoutAlign="center center"
                    class="page-disabled"
                >
                    <img
                        class="step-icon"
                        src="assets/img/application-icons/disclosure-icon.svg"
                        alt=""
                    />
                    <span fxHide.xs>{{ t("application.tab.disclosure") }}</span>
                </a>
            </div>
        </div>
    </div>
    <div class="content-area">
        <div fxFlex="100" fxLayoutAlign="center start" class="container">
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-container>
